var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#70b246;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-4{fill:#e8dcff;}.cls-5{fill:#ff715d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.07,722.92A277.79,277.79,0,0,0,462.74,779.7C443,794.79,425.05,813,414.62,835.55s-12.43,49.83-1.06,71.89C431.24,941.69,476.19,954,514,946.31s70.23-30.85,102-52.65S681.71,850.22,720,846.22c27.38-2.86,63.18,4,83.29-20.12,14.52-17.38,12.92-38.6-4.27-52.16C756.41,740.29,683.93,723.09,631.07,722.92Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flower_2",
    "data-name": "flower 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M752.69,802c-3.13,37.41-9.74,75.08-5,112.27s24,75.11,55.44,85.42c26.14,8.57,55-4.25,74.38-26.16S908.09,921.88,916,892c33.93-128.68,10.43-275.55-61.11-381.89-21.13-31.41-47-60.05-79.18-74.53-21.44-9.65-77.78-20.15-91.26,11-10.81,24.93,27.42,80.44,35.77,104A606.43,606.43,0,0,1,752.69,802Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.07,722.92A277.79,277.79,0,0,0,462.74,779.7C443,794.79,425.05,813,414.62,835.55s-12.43,49.83-1.06,71.89C431.24,941.69,476.19,954,514,946.31s70.23-30.85,102-52.65S681.71,850.22,720,846.22c27.38-2.86,63.18,4,83.29-20.12,14.52-17.38,12.92-38.6-4.27-52.16C756.41,740.29,683.93,723.09,631.07,722.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M732.41,793s-154.09-42.19-256.82,80.72"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.81,105.36c-24.08-18.35-58-25.87-85.37-12.9S495.33,141.83,510,168.35c10.85,19.69,35.25,31.51,39.64,53.56,4.08,20.5-12.15,40.3-31.11,49.09s-40.45,9.82-60.93,14A199,199,0,0,0,334,367.72c-18.51,27.45-28.4,67.88-5,91.35,17.31,17.39,45.59,17.42,69.33,11.22s46.45-17.45,71-18.79,52.59,11.63,57,35.77c3,16.74-6,33.05-14.45,47.81-12.85,22.4-25.36,45.65-29.7,71.11s.77,53.87,19.13,72c24.76,24.49,65.73,23.48,98.06,10.53,51.38-20.58,91.14-67.94,102.52-122.1,4.41-21,5.16-43.71,17.12-61.53,14.62-21.78,43.07-30.68,69.28-29.39s51.14,11,76,19.35c33,11.07,67.77,20,102.4,16.2s69.37-22.41,84.18-54,3-75.43-29.11-88.85c-16.39-6.84-34.88-5.33-52.51-7.46s-37-10.12-42.67-26.93c-5.51-16.21,4.25-34.07,17.4-45s29.47-17.35,43.62-27c45.65-31,62.12-98.15,36-146.77s-91.16-72-142.24-51.06c-27.17,11.13-48.84,32.3-69,53.69s-39.83,43.89-65,58.94c-22.09,13.19-59.19,27.35-75.22.37C656.33,150.85,650,125.33,623.81,105.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M617.32,295.48c-24.55,28.92-29.8,74.7-7.28,105.23,19.91,27,57.26,37.43,90.2,31s61.59-27.23,83.9-52.29c19.77-22.21,36-52.81,26-80.8C783.74,225,656.56,249.26,617.32,295.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M921.41,673s42.42,180.19-43.94,300.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M726.33,568.78s36.49,94.3,28.16,201.45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects26);
export default __webpack_public_path__ + "static/media/objects-26.a6390ad3ece897f1898f71f3f5718a8b.svg";
export { ForwardRef as ReactComponent };